export default __webpack_public_path__ + "static/media/iranyekanwebregular.532d4e8b.ttf";